import * as o from "react";
function Q(e, t) {
  if (t === e)
    return !1;
  const s = Object.values(t), r = Object.values(e);
  if (s.length !== r.length || s.some((a, c) => a !== r[c]))
    return !0;
  const n = Object.keys(e);
  return Object.keys(t).some((a, c) => a !== n[c]);
}
function b(e, t) {
  return e.matches[t] = !1, e.mediaQueries[t] = {}, e;
}
function h(e) {
  const t = Object.keys(e);
  return typeof window > "u" ? t.reduce(b, {
    mediaQueries: {},
    matches: {}
  }) : t.reduce((s, r) => {
    const n = window.matchMedia(e[r]);
    return s.mediaQueries[r] = n, s.matches[r] = n.matches, s;
  }, {
    mediaQueries: {},
    matches: {}
  });
}
function v(e, t) {
  function s(r, n) {
    return r[n] = e.mediaQueries[n].matches, r;
  }
  switch (t.type) {
    case "updateMatches":
      return {
        matches: Object.keys(e.mediaQueries).reduce(s, {}),
        mediaQueries: e.mediaQueries
      };
    case "setQueries":
      return h(t.queries);
  }
}
function j(e) {
  const t = o.useRef(e), [s, r] = o.useReducer(v, e, h);
  o.useEffect(() => {
    Q(e, t.current) && (r({
      type: "setQueries",
      queries: e
    }), t.current = e);
  }, [e]);
  function n() {
    return r({
      type: "updateMatches"
    });
  }
  function a(i) {
    const u = n;
    return typeof i.addListener < "u" ? i.addListener(u) : i.addEventListener("change", u), u;
  }
  o.useEffect(() => {
    const i = Object.values(s.mediaQueries), u = i.map(a);
    function l(f, m) {
      typeof f.addListener < "u" ? f.removeListener(u[m]) : f.removeEventListener("change", u[m]);
    }
    return () => {
      i.forEach(l);
    };
  }, [s.mediaQueries]);
  const {
    matches: c
  } = s, d = o.useMemo(() => Object.values(c), [c]);
  return {
    matches: c,
    matchesAny: d.some(Boolean),
    matchesAll: d.length > 0 && d.every(Boolean)
  };
}
export {
  j as useMediaQueries
};
